import { yupResolver } from "@hookform/resolvers/yup";
import {
  useCreateLeadTime,
  useUpdateLeadTime,
} from "hooks/lead-times/useLeadTime";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Col, Form, FormGroup, Label, Row } from "reactstrap";
import * as yup from "yup";
import MessageFormValidate from "../../../components/shared-components/MessageFormValidate";
import { formValidate } from "../../../helpers/form_helper";

const CustomerLeadTimeForm = ({
  leadTime,
  customerId,
  onSuccess,
  type,
  listTransport,
  listOrderType,
  ...props
}) => {
  const { t } = useTranslation(["order"]);
  const tCustomer = useTranslation(["customer"]).t;

  const initDefaultValues = {
    type: leadTime?.type
      ? listOrderType.find(
          item => Number(item.value) === Number(leadTime?.type)
        )
      : null,
    transporter_id: leadTime?.transporter_id
      ? listTransport.find(
          item => Number(item.value) === Number(leadTime?.transporter_id)
        )
      : null,
    forwarded_time: leadTime?.forwarded_time || 0,
    delivered_time: leadTime?.delivered_time || 0,
    completed_time: leadTime?.completed_time || 0,
    collected_time: leadTime?.collected_time || 0,
    customer_id: leadTime?.customer_id || customerId,
  };

  const onLeadTimeSuccess = data => {
    onSuccess?.(data.data);
  };
  const { mutate: createLeadTime } = useCreateLeadTime(onLeadTimeSuccess);
  const { mutate: updateLeadTime } = useUpdateLeadTime(onLeadTimeSuccess);
  const validator = {
    transporter_id: yup.object().nullable(),
    forwarded_time: yup.string().nullable(),
    // .required(
    //   t("form.validate.required", { title:tCustomer("form.lead_time._contact_phone") })
    // )
    delivered_time: yup.string().nullable(),
    completed_time: yup.string().nullable(),
    collected_time: yup.string().nullable(),
    type: yup.object().nullable(),
  };
  const addressValidationSchema = yup.object().shape(validator);

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting, isDirty },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(addressValidationSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultValues,
  });
  const handleSubmitForm = () => {
    trigger();
    handleSubmit(() => {
      const data = getValues();
      data.transporter_id = data.transporter_id?.value || null;
      data.type = data.type?.value || null;
      if (leadTime) {
        data.id = leadTime.id;
        updateLeadTime(data);
      } else {
        createLeadTime(data);
      }
    })();
  };
  return (
    <Form className="p-4">
      <Row xs={1} md={2}>
        <Col>
          <FormGroup>
            <Label htmlFor="transporter_id">
              {tCustomer("form.lead_time.transporter_id")}
            </Label>
            <Controller
              control={control}
              name="transporter_id"
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("placeholder.select", {
                    title: tCustomer("form.lead_time.transporter_id"),
                  })}
                  options={listTransport}
                  isSearchable
                  className="basic-single w-100"
                />
              )}
            />
            {errors.transporter_id && (
              <MessageFormValidate error={errors.transporter_id.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="type">{tCustomer("form.lead_time.type")}</Label>
            <Controller
              control={control}
              name="type"
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("placeholder.select", {
                    title: tCustomer("form.lead_time.type"),
                  })}
                  options={listOrderType}
                  isSearchable
                  className="basic-single w-100"
                />
              )}
            />
            {errors.type && <MessageFormValidate error={errors.type.message} />}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="forwarded_time">
              {tCustomer("form.lead_time.forwarded_time")}
            </Label>
            <input
              name="forwarded_time"
              type="number"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "forwarded_time"
              )}`}
              placeholder={t("placeholder.enter", {
                title: tCustomer("form.lead_time.forwarded_time"),
              })}
              {...register("forwarded_time")}
            />
            {errors.forwarded_time && (
              <MessageFormValidate error={errors.forwarded_time.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="delivered_time">
              {tCustomer("form.lead_time.delivered_time")}
            </Label>
            <input
              name="delivered_time"
              type="number"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "delivered_time"
              )}`}
              placeholder={t("placeholder.enter", {
                title: tCustomer("form.lead_time.delivered_time"),
              })}
              {...register("delivered_time")}
            />
            {errors.delivered_time && (
              <MessageFormValidate error={errors.delivered_time.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="completed_time">
              {tCustomer("form.lead_time.completed_time")}
            </Label>
            <input
              name="completed_time"
              type="number"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "completed_time"
              )}`}
              placeholder={t("placeholder.enter", {
                title: tCustomer("form.lead_time.completed_time"),
              })}
              {...register("completed_time")}
            />
            {errors.completed_time && (
              <MessageFormValidate error={errors.completed_time.message} />
            )}
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="collected_time">
              {tCustomer("form.lead_time.collected_time")}
            </Label>
            <input
              name="collected_time"
              type="number"
              className={`form-control ${formValidate(
                errors,
                touchedFields,
                "collected_time"
              )}`}
              placeholder={t("placeholder.enter", {
                title: tCustomer("form.lead_time.collected_time"),
              })}
              {...register("collected_time")}
            />
            {errors.collected_time && (
              <MessageFormValidate error={errors.collected_time.message} />
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            color="danger"
            outline
            className="border-0"
            size="xs"
            onClick={props?.handleCancel}
          >
            {t("button.cancel")}
          </Button>
        </Col>
        <Col className="text-end">
          <Button
            size="xs"
            color="primary"
            style={{ backgroundColor: "#3C64B1" }}
            onClick={handleSubmitForm}
          >
            {leadTime ? t("button.update") : t("button.add")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};
export default CustomerLeadTimeForm;
